// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"styles_breadcrumb__3BfQg","item":"styles_item__MZ4g4"};